import useEntity from "../../hooks/useRolePermission";
import RolePermissionDetail from "../../components/rolePermission/RolePermissionDetail/RolePermissionDetail";
import RolePermissionScoped from "../../components/rolePermission/RolePermissionDetail/RolePermissionScoped";
import RolePermissionTabs from "../../components/rolePermission/RolePermissionDetail/RolePermissionTabs";
import { useGetRolePermissionQuery } from "../../apis/RolePermission.api";
import { PrimaryRolePermission } from "../../types/models/RolePermission";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const RolePermissionDetailPage = () => {

    useTitle(t`Details Role Permission`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { rolePermissionId: id } = useParams();

    const { data, refetch } = useGetRolePermissionQuery(PrimaryRolePermission.fromPath(id))
    const { deleteRolePermission } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteRolePermission(data, '..')
    }, [data, deleteRolePermission])

    if (id === 'scoped') {
        return (<RolePermissionScoped/>)
    }

    return (
        <Box data-testid="RolePermission-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <RolePermissionDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/RolePermissions/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="RolePermission-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <RolePermissionTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default RolePermissionDetailPage;
